<template>
    <div 
        id="monitor_qpe" 
        class="base-popup monitor-graph" 
        :style="css_props"
    >
        <v-card 
            class="base-popup__wrapper" 
            v-if="Object.keys(timeseries_data).length !== 0"
        >
            <div 
                id="base-popup__capture_range" 
                class="base-popup__container"
            >
                <div class="base-popup__tooltip">
                    <!-- 右側標題區 -->
                    <div class="base-popup__tooltip-title">
                        <div>
                            <div class="base-popup__tooltip-title__city_info">
                                <h1>{{ station_title }}</h1>
                            </div>
                            <v-btn
                                class="base-popup__tooltip-close-btn"
                                color="white"
                                icon
                                @click="close_dialog"
                            >
                                <v-icon color="white"> 
                                    icon-close 
                                </v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <!-- 左側下拉選單區 -->
                    <div class="base-popup__tooltip-selection">
                        <div class="selection-input">
                            <v-select
                                v-model="item_selected"
                                :items="item_select"
                                id="tsgraph-select-type"
                                item-text="text"
                                item-value="value"
                                :label="$t('__monitor_weather.weather_variable')"
                            />
                        </div>
                        <div class="selection-input">
                            <v-select
                                v-model="variable_selected"
                                :items="variable_select"
                                id="tsgraph-select-type"
                                item-text="text"
                                item-value="value"
                                label="雨量時間"
                            />
                        </div>
                        <div class="selection-input">
                            <v-select
                                v-model="day_selected"
                                :items="day_select"
                                id="tsgraph-select-day"
                                item-text="text"
                                item-value="value"
                                :label="$t('__chart_common.day_select_text')"
                            />  
                        </div>
                    </div>
                </div>
                <div class="base-popup__content">
                    <div class="base-popup__content-detail d-flex justify-space-between">
                        <div class="d-flex align-center">
                            {{ is_pad_width ? props_svg_sub_title.time : props_svg_sub_title.full_title }}
                            <v-btn v-if="!is_mobile_width"
                                id="tsgraph-reset-btn" 
                                icon
                            >
                                <v-icon 
                                    color="black"
                                    @click="reset_time_range"
                                >
                                    icon-autorenew
                                </v-icon>
                            </v-btn>
                        </div>
                        <div v-if="!is_mobile_width">
                            <v-btn
                                id="tsgraph-download" 
                                @click="save_png"
                                icon
                            >
                                <v-icon color="black">
                                    icon-file-download
                                </v-icon>
                            </v-btn>
                            <v-btn
                                class="close-btn"
                                color="black"
                                icon
                                @click="close_dialog"
                            >
                                <v-icon color="black">
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </div>
                        <v-menu 
                            v-if="is_mobile_width" 
                            offset-y
                        >
                            <template #activator="{ on, attrs }">
                                <v-btn
                                    color="black"
                                    dark
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>icon-more</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="reset_time_range">
                                    <v-icon color="black">
                                        icon-autorenew
                                    </v-icon>
                                    {{$t('__chart_common.reset_time_range')}}
                                </v-list-item>
                                <v-list-item @click="save_png">
                                    <v-icon color="black">
                                        icon-file-download
                                    </v-icon>
                                    {{$t('__chart_common.save_image')}}
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <div 
                        v-if="should_draw_histogram_diagram_header.includes(variable_selected)"
                        class="base-popup__content-legend"
                    >
                        <span class="legend histogram" /> {{ variable_selected }}雨量(mm)
                        <span class="legend no-data-label">&#10010;</span> {{ $t('__chart_common.legend_no_data') }}
                    </div>
                    <div class="base-popup__content-graph">
                        <QpeHistogram 
                            v-if="should_draw_histogram_diagram_header.includes(variable_selected)"
                            ref="chart"
                            :choosed_time_series_data="choosed_time_series_data"
                            :x_axis_time_series_data="x_axis_time_series_data"
                            :svg_main_title="station_name"
                            :svg_sub_title="props_svg_sub_title.full_title"
                            :basic_layout_setting="basic_layout_setting"
                            :x_axis="x_axis"
                            :y_axis="y_axis"
                            :tooltip_value_text="tooltip_value_text"
                            :tooltip_value_unit="tooltip_value_unit"
                            :show_data_end_time="false"
                        />
                    </div>

                    <div class="time-slider">
                        <div class="time-slider__content-container">
                            <span 
                                class="time-slider__content-before" 
                                @click="change_dragged_index_to_first"
                            />
                            <v-slider
                                v-model="dragged_index"
                                :max="max_dragged_index"
                                :min="min_dragged_index"
                                class="time-slider__content"
                                :tick-labels="slider_tick_labels"
                                ticks="always"
                                tick-size="4"
                            />
                            <span 
                                class="time-slider__content-after" 
                                @click="change_dragged_index_to_last"
                            />
                        </div>
                        <span class="time-slider__icon-container">
                            <v-icon 
                                class="time-slider__icon"
                                @click="minus_dragged_index_a_unit"
                            >
                                icon-backward-10
                            </v-icon>
                            <v-icon 
                                class="time-slider__icon"
                                @click="plus_dragged_index_a_unit"
                            >
                                icon-forward-10
                            </v-icon>
                        </span>
                    </div>
                </div>
            </div>
        </v-card>
        <v-card v-else>
            <v-alert
                :value="true"
                type="error"
                class="alert"
            >
                暫時無法顯示歷史圖表
            </v-alert>
        </v-card>
    </div>
</template>

<script>
    import { 
        transform_datetime_str_to_chart_need_format, 
    } from '@/utils/common/custom_time.js'
    import { 
        judge_value_valid, 
        judge_extreme_value_valid 
    } from '@/utils/chart/verification.js'
    import debounce from 'lodash/debounce';
    import * as d3 from 'd3';
    import QpeHistogram from './qpe_histogram.vue'

    export default {
        name: 'monitor_qpe',
        
        components: {
            QpeHistogram
        },

        props: {
            timeseries_data: {
                type: Object,
                default () {
                    return {}
                }
            },
            default_variable: {
                type: String,
                default () {
                    return ''
                }
            },
        }, 

        data() {
            return {
                item_selected: '雨量',
                item_select: [{value: '雨量', text: '雨量'}],
                variable_selected: '',
                variable_text_obj: {
                    qpe_1h_max: '一小時最大',
                    qpe_1h_ave: '一小時平均',
                    qpe_3h_ave: '三小時平均',
                    qpe_6h_ave: '六小時平均',
                    qpe_12h_ave: '十二小時平均',
                    qpe_24h_ave: '二十四小時平均',
                    qpe_72h_ave: '七十二小時平均'
                },
                day_selected: '1',
                variable_select: [
                    {value: '一小時最大', text: '一小時最大雨量'}, 
                    {value: '一小時平均', text: '一小時平均雨量'}, 
                    {value: '三小時平均', text: '三小時平均雨量'}, 
                    {value: '六小時平均', text: '六小時平均雨量'}, 
                    {value: '十二小時平均', text: '十二小時平均雨量'}, 
                    {value: '二十四小時平均', text: '二十四小時平均雨量'}, 
                    {value: '七十二小時平均', text: '七十二小時平均雨量'}
                ],
                
                day_select: [
                    {'text':'1天', 'value':'1'}, {'text':'2天', 'value':'2'},
                    {'text':'3天', 'value':'3'}, {'text':'4天', 'value':'4'},
                    {'text':'5天', 'value':'5'}, {'text':'6天', 'value':'6'}
                ],
                
                variable_value_mapping: {
                    '一小時最大': {
                        text: '一小時最大雨量(mm)',
                        data_key: '一小時最大',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '一小時平均': {
                        text: '一小時平均雨量(mm)',
                        data_key: '一小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '三小時平均': {
                        text: '三小時平均雨量(mm)',
                        data_key: '三小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '六小時平均': {
                        text: '六小時平均雨量(mm)',
                        data_key: '六小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '十二小時平均': {
                        text: '十二小時平均雨量(mm)',
                        data_key: '十二小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '二十四小時平均': {
                        text: '二十四小時平均雨量(mm)',
                        data_key: '二十四小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                    '七十二小時平均': {
                        text: '七十二小時平均雨量(mm)',
                        data_key: '七十二小時平均',
                        default_max: 10,
                        default_min: 0,
                        display_interval: 1,
                        ticks: 5
                    },
                },

                x_axis: {
                    'label': '時間',
                    'ticks': 24, // 跟橫軸顯示有關
                    'display_interval': 2, // 顯示標籤文字的間隔
                    'label_distance': 40 // label文字跟橫軸的距離
                },
                
                basic_layout_setting: {
                    'margin': {
                        'top': 50,
                        'right': 50,
                        'bottom': 50,
                        'left': 30,
                    }
                },

                dragged_index: Object.keys(this.timeseries_data['data_time']).length > 0 ? this.timeseries_data['data_time'].length : 0,

                should_draw_histogram_diagram_header: ['一小時最大', '一小時平均', '三小時平均', '六小時平均', '十二小時平均', '二十四小時平均', '七十二小時平均'],
            }
        },
        
        computed: {
            css_props() {
                const get_total_slider_width = () => {
                    const is_mobile  = window.matchMedia("(max-width: 767px)").matches;
                    const is_pad = window.matchMedia("(max-width: 1024px)").matches;

                    if (is_mobile) {
                        return 75
                    }
                    
                    if(is_pad) {
                        return 90
                    }
                    
                    return 55
                }

                const total_slider_width = get_total_slider_width()

                const interval_count =  6 + 1 - this.day_selected
                const slider_thumb_width = (total_slider_width) / interval_count
                const slider_width = total_slider_width - slider_thumb_width
                const slider_pseudo_width = slider_thumb_width / 2
                return {
                    '--slider-thumb-width': `${slider_thumb_width}vw`,
                    '--slider-width': `${slider_width}vw`,
                    '--slider-pseudo-width': `${slider_pseudo_width}vw`,
                }
            },

            choosed_time_series_data() {
                return this.timeseries_data[this.variable_selected]
                    .slice(this.dragged_index - 1 - 144*this.day_selected, this.dragged_index)
            },

            time_list() {
                return this.timeseries_data['data_time']
            },

            x_axis_time_series_data() {
                return this.time_list
                    .slice(this.dragged_index - 1 - 144*this.day_selected, this.dragged_index)
            },

            max_dragged_index() {
                return this.time_list.length
            },

            station_title() {
                return `${this.timeseries_data['station_name']}  ${this.timeseries_data['station_code']}`
            },

            station_name() {
                return `${this.timeseries_data['station_name']}站`
            },

            props_svg_sub_title() {
                const station = `${this.variable_selected}雨量時序組體圖`
                const start_datetime = transform_datetime_str_to_chart_need_format(this.x_axis_time_series_data[0])
                const end_datetime = transform_datetime_str_to_chart_need_format(this.x_axis_time_series_data[this.x_axis_time_series_data.length-1])
                return {
                    full_title: `${station} ${start_datetime} ~ ${end_datetime}`,
                    station: `${station}`,
                    time: `${start_datetime} ~ ${end_datetime}`
                }
            },

            y_axis() {
                const { text, ticks, display_interval } = this.variable_value_mapping[this.variable_selected]
                return {
                    'label': text,
                    'ticks': ticks,
                    'display_interval': display_interval,
                    'label_distance': 50
                }
            },

            tooltip_value_text() {
                const { text } = this.variable_value_mapping[this.variable_selected]
                return text.split('(')[0]
            },

            tooltip_value_unit() {
                const { text } = this.variable_value_mapping[this.variable_selected]
                if (text.includes('(')) {
                    return text.split('(')[1].replace(')', '')
                }
                return ''
            },

            tooltip_value_icon_name() {
                const { icon } = this.variable_value_mapping[this.variable_selected]
                return icon
            },

            min_dragged_index() {
                return this.max_dragged_index - 144*(6 - this.day_selected)
            },

            slider_tick_labels() {
                const valid_timeseries_data = this.time_list
                    .slice(this.min_dragged_index, this.max_dragged_index)
                    .map((time, index) => {
                        if (index % 144 === 72) {
                            const prev_day_num = (6 - this.day_selected) - ((index-72) / 144)
                            if (prev_day_num > 0) {
                                return `${prev_day_num}天前`
                            }
                        }
                        return ''
                    })
                return valid_timeseries_data
            },

            is_mobile_width() {
                return window.innerWidth < 769
            },

            is_pad_width() {
                return window.innerWidth < 1025
            },
        },

        watch: {
            dragged_index() {
                this.calc_y_axis_max_min();
                this.debounce_call_rerender_function()
            },

            variable_selected: {
                handler() {
                    this.calc_y_axis_max_min()
                    this._call_rerender_function()
                }
            },

            day_selected: {
                handler() {
                    this.calc_y_axis_max_min()
                    this._call_rerender_function()
                }
            },
        },
        
        mounted() {
            this.dragged_index = this.time_list.length;
            this.variable_selected = this.variable_text_obj[this.default_variable];
            this.calc_y_axis_max_min();
        },

        methods: {
            reset_time_range() {
                this.day_selected = '1'
                this.dragged_index = this.timeseries_data['data_time'].length
            },

            change_dragged_index_to_first() {
                this.dragged_index = this.min_dragged_index
            },

            change_dragged_index_to_last() {
                this.dragged_index = this.max_dragged_index
            },

            minus_dragged_index_a_unit() {
                // v-model + v-slider 會幫忙把值鎖住
                this.dragged_index--
            },

            plus_dragged_index_a_unit() {
                this.dragged_index++
            },

            debounce_call_rerender_function: debounce(function() { // 不能 arrow function
                this._call_rerender_function()
            }, 150),

            // 重畫圖
            _call_rerender_function() {
                setTimeout(() => {
                    this.$refs.chart.rerender_svg()
                }, 0);
            },

            close_dialog() {
                this.$emit('close-chart-dialog');
            },

            save_png() {
                const { station_name, station_code, data_time } = this.timeseries_data
                const file_name = `${station_name}_${station_code}_${d3.timeFormat('%Y%m%d')(new Date())}_${data_time[data_time.length-1]}`
                this.$refs.chart.save_png(file_name)
            },

            // 跟y軸設定有關
            calc_y_axis_max_min() {
                const { default_max, default_min, nan_max, nan_min , plus, minus } = this.variable_value_mapping[this.variable_selected]
                const ignore_None_data = this.choosed_time_series_data.filter(datum => judge_value_valid(datum))
                
                if(['一小時最大', '一小時平均', '三小時平均', '六小時平均', '十二小時平均', '二十四小時平均', '七十二小時平均'].includes(this.variable_selected)) {
                    return this._calc_y_axis_max_min_for_accumlated_precp(ignore_None_data)
                }

                if (default_max !== undefined) {
                    this.y_axis.max_value = default_max
                } else {
                    const max_data_value = ignore_None_data.length > 0 ? Math.max(...ignore_None_data) : NaN
                    this.y_axis.max_value = judge_extreme_value_valid(max_data_value) ? max_data_value + plus : nan_max
                }

                if(default_min !== undefined) {
                    this.y_axis.min_value = default_min
                } else {
                    const min_data_value = ignore_None_data.length > 0 ? Math.min(...ignore_None_data) : NaN
                    this.y_axis.min_value = judge_extreme_value_valid(min_data_value) ? min_data_value - minus : nan_min
                }
            },

            // 取得雨量的y軸範圍
            _calc_y_axis_max_min_for_accumlated_precp(ignore_None_data) {
                this.y_axis.min_value = 0
                const max_data_value = ignore_None_data.length > 0 ? Math.max(...ignore_None_data) : NaN

                if (isNaN(max_data_value)) {
                    const NAN_MAX_VALUE = 10
                    this.y_axis.max_value = NAN_MAX_VALUE
                    return
                }

                const MAX_RANGE = [10, 50, 100 , 300 , 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000]
                this.y_axis.max_value = MAX_RANGE.find(value => value >= max_data_value)
            },
        },
    }
</script>

<style lang="scss" scoped>
@import '../../../css/base_popup.scss';

.legend {
    margin: 2px 5px;
}

.histogram {
    height: 1rem;
    width: 1rem;
    background-color: #4682b4;
    display: inline-block;
}

.no-data-label{
    color: red;
    font-weight: bold;
    transform: rotate(45deg);
}

.line {
    width: 2rem;
    border-top: 5px solid #4682b4;
    margin-bottom: 4px;
    display: inline-block;
}

@mixin triangle-base {
    width: 0px;
    height: 0px;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
}

.triangle {
    &__wind-max {
        @include triangle-base;
        border-top: 15px solid #ff0000;
    }

    &__wind-min {
        @include triangle-base;
        border-bottom: 15px solid #ffa500;
    }

    &__gust-max {
        @include triangle-base;
        border-top: 15px solid #0000ff;
    }
}

.circle {
    height: 1rem;
    width: 1rem;
    background-color: #4682b4;
    display: inline-block;
    border-radius: 1rem;
}

.cross {
    color: #0000ff;
}

.gust_time {
    color: purple;
    font-size: 0.8rem;
}

.back-station-title {
    margin-bottom: 0.25rem;

    @include laptop {
        position: absolute;
        top: 0;
        left: 16px;
    }

    &__text {
        font-size: 0.75rem;
        line-height: 1.33;
        letter-spacing: 0.5px;

        @include laptop {
            display: none;
        }
    }
}

.base-popup__tooltip-title__city_info {
    margin-left: 0.25rem;
}

</style>

<style lang="scss">

@mixin time_slider_psuedo_comment {
    content: '';
    position: absolute;
    width: var(--slider-pseudo-width);
    margin-top: 12px;
    height: 8px;
    background: #e8ecf7;
    border-radius: 9ex;
}

.base-popup {
    .time-slider {
        width: 100%;
        text-align: center;

        &__content {
            &-container {
                text-align: center;
                display: inline-block;
                margin-left: calc(1rem + var(--slider-pseudo-width));
            }

            display: inline-block;
            position: relative;
            width: var(--slider-width);

            &-before {
                @include time_slider_psuedo_comment;
                transform: translateX(calc(-100% + 1rem));
            }

            &-after {
                @include time_slider_psuedo_comment;
                transform: translateX(- 1rem);
                // z-index: -1;
            }
        }

        &__icon {
            transform: translateY(-50%);

            &::before {
                margin: 0 0.1rem;
            }

            &-container {
                margin-left: calc(var(--slider-pseudo-width) - 0.5rem);
            }
        }
    }
            
    }

    #monitor_qpe .v-slider__thumb {
        width: var(--slider-thumb-width);
        height: 8px;
        border-radius: 12px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.32);
        background-image: linear-gradient(to right, #124ed0 0%, #2366f8 99%);
        transform: translate(-50%, -50%);
        z-index: 1;

        &::before {
            content: none;
        }

        &::after {
            content: 'lll';
            color: #ffffff;
            position: absolute;
            transform: translate(calc(var(--slider-thumb-width) / 2 - 50%) , -40%);
        }
    }

    #monitor_qpe .v-slider__track-container {
        height: 8px !important;
        margin: 0 0 0 1px;
        background-color: #e8ecf7;

        .v-slider__track-background {
            background-color: #e8ecf7 !important;
        }

        .v-slider__track-fill {
            background-color: #e8ecf7 !important;
        }
    }

    .v-slider__ticks-container {
        .v-slider__tick {
            background-color: #e8ecf7 !important;
            
            &--filled {
                background-color: #e8ecf7 !important;
            }

            &-label {
                height: 14px;
                font-family: NotoSansCJKtc;
                font-size: 11px;
                line-height: 1.27;
                letter-spacing: 0.5px;
                color: #b3b7c4;
            }
        }
}

.back-station-title {
    .v-btn--icon.v-size--default {
        width: 1.5rem;
    }

    .v-btn::before {
        transform: translateX(-0.65rem);
        width: 2rem;
    }

    .v-btn__content {
        margin-right: 0.75rem;
    }
}
</style>